import { Button } from "iparque-components";
import styled from "styled-components";

export const StyledButton = styled(Button)`
  padding: 0;
  text-decoration: underline;
`;
